module.exports = __webpack_public_path__ + "img/34200.413ae23a.jpg";